import { IconMail } from '@tabler/icons-react';
import { CustomIconMPA, CustomIconSMS } from '@/assets';
import { DELIVERY_METHOD } from '@/types';

const deliveryMethodIconComponents = {
  [DELIVERY_METHOD.APP]: CustomIconMPA,
  [DELIVERY_METHOD.EMAIL]: IconMail,
  [DELIVERY_METHOD.TEXT]: CustomIconSMS,
};

export const getDeliveryMethodIcon = (method: DELIVERY_METHOD, size: number) => {
  const IconComponent = deliveryMethodIconComponents[method];
  return <IconComponent size={size} />;
};
